const permissionConfig = {
  name: 'Permission',
  endpoint: '/internal_admin/admin_kit/permissions',
  modelKey: 'rbac_permission',

  columns: [
    { name: 'name', title: 'Name', type: 'link' },
    { name: 'description', title: 'Description' },
    { name: 'public', title: 'Public', type: 'boolean' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[name_cont]', label: 'Name' },
    { name: 'q[description_cont]', label: 'Description' },
    {
      name: 'q[public_eq]',
      label: 'Public',
      options: () => [
        { id: 'true', label: 'Yes', value: 'true' },
        { id: 'false', label: 'No', value: 'false' },
      ],
    },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'name', label: 'Name' },
    { name: 'description', label: 'Description' },
    { name: 'documentation', label: 'Documentation' },
    { name: 'public', label: 'Public', type: 'boolean' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  form: {
    fields: [
      { name: 'name', label: 'Name', type: 'text', required: true },
      {
        name: 'description',
        label: 'Description',
        type: 'text',
        required: true,
      },
      { name: 'documentation', label: 'Documentation', type: 'text' },
      {
        name: 'public',
        label: 'Public',
        type: 'checkbox',
        defaultValue: false,
      },
    ],
  },
};

export default permissionConfig;
